import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('MarketplaceConnection')
export class MarketplaceConnection {
  @JsonProperty('id', Number, true) id: number = undefined;
  @JsonProperty('name', String, true) name: string = undefined;
  @JsonProperty('marketplaceConnectionType', String, true) marketplaceConnectionType: string = undefined;
}
